module.exports = __webpack_public_path__ + "img/dataanalysis.51d8b391.png";